import { render, staticRenderFns } from "./CustomSortableTable.vue?vue&type=template&id=87eb626e&scoped=true&"
import script from "./CustomSortableTable.vue?vue&type=script&lang=js&"
export * from "./CustomSortableTable.vue?vue&type=script&lang=js&"
import style0 from "./CustomSortableTable.vue?vue&type=style&index=0&id=87eb626e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87eb626e",
  null
  
)

export default component.exports